import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: '',
        data: { pageTitle: 'Home' },
        loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
      },
      {
        path: 'devilery',
        data: { pageTitle: 'Devileries' },
        loadChildren: () => import('../entities/devilery/devilery.module').then(m => m.DevileryModule),
      },
      {
        path: 'device',
        data: { pageTitle: 'Devices' },
        loadChildren: () => import('../entities/device/device.module').then(m => m.DeviceModule),
      },
      {
        path: 'upload',
        data: { pageTitle: 'Upload' },
        loadChildren: () => import('./upload/upload.module').then(m => m.UploadModule),
      },
      /* jhipster-needle-add-entity-route - JHipster will add entity modules routes here */
    ]),
  ],
})
export class PagesRoutingModule {}
